import { Component } from '@angular/core';

@Component({
  templateUrl: './offline.component.html',
  standalone: true,
})
export class OfflineComponent {}
